<div class="service-badge service-badge--{{service}}">
  <mat-icon class="service-badge__icon" [svgIcon]="'services:' + service"></mat-icon>
  <span class="service-badge__text">{{ text }}</span>
</div>
